import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views - Pages
import Page404 from '@/views/pages/Page404'
//import Page500 from '@/views/pages/Page500'
import Page401 from '@/views/pages/Page401'

import Login from '@/views/pages/Login'
//import Register from '@/views/pages/Register'



Vue.use(Router)

var router = new Router({
    mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/system/users',
            name: 'default',
            component: TheContainer,
            meta: { requiresAuth: true, label: 'Trang chủ' },
            children: [
                // {
                //     path: 'home',
                //     name: 'home',
                //     meta: { label: 'Trang chủ', requiresAuth: true },
                //     component: () => import('@/views/home')
                // },
                {
                    path: 'system',
                    name: 'system',
                    redirect: '/system/users',
                    meta: { label: 'Hệ thống' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'users',
                            name: 'users',
                            redirect: '/system/users/list',
                            meta: { label: 'Người dùng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'user_list',
                                    meta: { label: 'Danh sách người dùng', requiresAuth: true, requiresPrivileges: ['ViewUser'] },
                                    component: () => import('@/views/system/users/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_user',
                                    meta: { label: 'Thêm mới người dùng', requiresAuth: true, requiresPrivileges: ['ManageUser'] },
                                    component: () => import('@/views/system/users/create')
                                },
                                {
                                    path: 'detail/:userId',
                                    name: 'users_detail',
                                    meta: { label: 'Xem thông tin chi tiết người dùng', title: 'Xem chi tiết thông tin người dùng', requiresAuth: true, param: 'userId', requiresPrivileges: ['ViewUser'], editing: true, },
                                    component: () => import('@/views/system/users/detail')
                                },
                                {
                                    path: 'edit/:userId',
                                    name: 'users_edit',
                                    meta: { label: 'Sửa người dùng', title: 'Sửa người dùng', requiresAuth: true, param: 'userId', requiresPrivileges: ['ManageUser'], editing: true, },
                                    component: () => import('@/views/system/users/detail')
                                },
                                {
                                    path: 'privileges/:userId',
                                    name: 'users_privileges',
                                    meta: { label: 'Phân quyền', title: 'Phân quyền', requiresAuth: true, param: 'userId', requiresPrivileges: ['ManageUser'], editing: true, },
                                    component: () => import('@/views/system/users/privileges')
                                }
                            ]
                        },
                        {
                            path: 'roles',
                            name: 'roles',
                            redirect: '/system/roles/list',
                            meta: { label: 'Nhóm người dùng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'role_list',
                                    meta: { label: 'Danh sách nhóm người dùng', requiresAuth: true, requiresPrivileges: ['ViewRole'] },
                                    component: () => import('@/views/system/roles/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_role',
                                    meta: { label: 'Thêm mới nhóm người dùng', requiresAuth: true, requiresPrivileges: ['ManageRole'] },
                                    component: () => import('@/views/system/roles/create')
                                },
                                {
                                    path: ':roleId',
                                    redirect: '/system/roles/:roleId/detail',
                                    name: 'role_detail',
                                    meta: { label: 'Thông tin nhóm người dùng', param: 'roleId', requiresAuth: true, requiresPrivileges: ['ViewRole', 'ManageRole'] },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: 'detail',
                                            name: 'role_detail_info',
                                            meta: { label: 'Chi tiết', requiresAuth: true, requiresPrivileges: ['ViewRole', 'ManageRole'] },
                                            component: () => import('@/views/system/roles/detail')
                                        },
                                        {
                                            path: 'privileges',
                                            name: 'role_privileges',
                                            meta: { label: 'Phân quyền', requiresAuth: true, requiresPrivileges: ['ManageRole'] },
                                            component: () => import('@/views/system/roles/privileges')
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            path: 'menus',
                            name: 'menus',
                            redirect: '/system/menus/list',
                            meta: { label: 'Menu' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'menu_list',
                                    meta: { label: 'Danh sách menu', requiresAuth: true, requiresPrivileges: ['ViewMenu'] },
                                    component: () => import('@/views/system/menus/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_menu',
                                    meta: { label: 'Thêm mới menu', requiresAuth: true, requiresPrivileges: ['ManageMenu'] },
                                    component: () => import('@/views/system/menus/create')
                                },
                                {
                                    path: 'detail/:menuId',
                                    name: 'detail_menu',
                                    meta: { label: 'Xem thông tin chi tiết menu', requiresAuth: true, requiresPrivileges: ['ViewMenu'] },
                                    component: () => import('@/views/system/menus/detail')
                                },
                                {
                                    path: 'edit/:menuId',
                                    name: 'edit_menu',
                                    meta: {
                                        label: 'Sửa menu', requiresAuth: true, editing: true,
                                        requiresPrivileges: ['ManageMenu'],
                                    },
                                    component: () => import('@/views/system/menus/detail')
                                },
                            ]
                        },
                        {
                            path: 'slider-video-types',
                            name: 'slider-video-types',
                            redirect: '/system/slider-video-types/list',
                            meta: { label: 'Danh mục slider' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'slider-video-types_list',
                                    meta: { label: 'Danh sách danh mục slider', requiresAuth: true, requiresPrivileges: ['ViewSliderVideoType'] },
                                    component: () => import('@/views/system/slider-video-types/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_slider-video-types',
                                    meta: { label: 'Thêm mới danh mục slider', requiresAuth: true, requiresPrivileges: ['ManageSliderVideoType'] },
                                    component: () => import('@/views/system/slider-video-types/create')
                                },
                                {
                                    path: 'detail/:tagId',
                                    name: 'slider-video-types_detail',
                                    meta: { label: 'Thông tin danh mục slider', requiresAuth: true, param: 'tagId', requiresPrivileges: ['ViewSliderVideoType'] },
                                    component: () => import('@/views/system/slider-video-types/detail')
                                },
                                {
                                    path: 'edit/:tagId',
                                    name: 'slider-video-types_edit',
                                    meta: { label: 'Sửa thông tin danh mục slider', requiresAuth: true, param: 'tagId', requiresPrivileges: ['ManageSliderVideoType'], editing: true, },
                                    component: () => import('@/views/system/slider-video-types/detail')
                                }
                            ]
                        },
                        {
                            path: 'sliders',
                            name: 'sliders',
                            redirect: '/system/sliders/list',
                            meta: { label: 'Trình chiếu' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'sliders_list',
                                    meta: { label: 'Danh sách trình chiếu', requiresAuth: true, requiresPrivileges: ['ViewSlider'] },
                                    component: () => import('@/views/system/sliders/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_slider',
                                    meta: { label: 'Thêm mới trình chiếu', requiresAuth: true, requiresPrivileges: ['ManageSlider'] },
                                    component: () => import('@/views/system/sliders/create')
                                },
                                {
                                    path: 'detail/:sliderId',
                                    name: 'detail_slider',
                                    meta: { label: 'Chi tiết trình chiếu', requiresAuth: true, requiresPrivileges: ['ViewSlider'] },
                                    component: () => import('@/views/system/sliders/detail')
                                },
                                {
                                    path: 'edit/:sliderId',
                                    name: 'edit_slider',
                                    meta: {
                                        label: 'Sửa trình chiếu', requiresAuth: true, editing: true,
                                        requiresPrivileges: ['ManageSlider']
                                    },
                                    component: () => import('@/views/system/sliders/detail')
                                }
                            ]
                        },
                        {
                            path: 'config-display',
                            name: 'config-display',
                            redirect: '/system/config-display/list',
                            meta: { label: 'Cấu hình hiển thị' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'config-display_list',
                                    meta: { label: 'Danh sách cấu hình hiển thị', requiresAuth: true, requiresPrivileges: ['ViewConfigDisplay'] },
                                    component: () => import('@/views/system/config-display/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_config-display',
                                    meta: { label: 'Thêm mới cấu hình hiển thị', requiresAuth: true, requiresPrivileges: ['ManageConfigDisplay'] },
                                    component: () => import('@/views/system/config-display/create')
                                },
                                {
                                    path: 'detail/:sliderId',
                                    name: 'detail_config-display',
                                    meta: { label: 'Chi tiết cấu hình hiển thị', requiresAuth: true, requiresPrivileges: ['ViewConfigDisplay'] },
                                    component: () => import('@/views/system/config-display/detail')
                                },
                                {
                                    path: 'edit/:sliderId',
                                    name: 'edit_config-display',
                                    meta: {
                                        label: 'Sửa cấu hình hiển thị', requiresAuth: true, editing: true,
                                        requiresPrivileges: ['ManageConfigDisplay']
                                    },
                                    component: () => import('@/views/system/config-display/detail')
                                },
                                {
                                    path: ':sliderId/config',
                                    name: 'config_config-display',
                                    meta: { label: 'Chi tiết cấu hình hiển thị', requiresAuth: true, requiresPrivileges: ['ManageConfigDisplay'] },
                                    component: () => import('@/views/system/config-display/config')
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'master-data',
                    name: 'master_data',
                    redirect: '/master-data/categories/',
                    meta: { label: 'Danh mục' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'categories',
                            name: 'categories',
                            redirect: '/master-data/categories/list',
                            meta: { label: 'Danh mục sản phẩm' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'categories_list',
                                    meta: { label: 'Danh sách danh mục sản phẩm', requiresAuth: true, requiresPrivileges: ['ViewCategory'] },
                                    component: () => import('@/views/master-data/categories/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_categories',
                                    meta: { label: 'Thêm mới danh mục sản phẩm', requiresAuth: true, requiresPrivileges: ['ManageCategory'] },
                                    component: () => import('@/views/master-data/categories/create')
                                },
                                {
                                    path: 'detail/:categoryId',
                                    meta: { label: 'Thông tin danh mục sản phẩm', requiresAuth: true, param: 'categoryId', requiresPrivileges: ['ViewCategory'] },
                                    component: () => import('@/views/master-data/categories/detail')
                                },
                                {
                                    path: 'edit/:categoryId',
                                    name: 'categories_edit',
                                    meta: { label: 'Thông tin danh mục sản phẩm', requiresAuth: true, param: 'categoryId', requiresPrivileges: ['ManageCategory'], editing: true, },
                                    component: () => import('@/views/master-data/categories/detail')
                                }
                            ]
                        },
                        {
                            path: 'products',
                            name: 'products',
                            redirect: '/master-data/products/list',
                            meta: { label: 'Sản phẩm' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'products_list',
                                    meta: { label: 'Danh sách Sản phẩm', requiresAuth: true, requiresPrivileges: ['ViewProduct'] },
                                    component: () => import('@/views/master-data/products/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_products',
                                    meta: { label: 'Thêm mới', requiresAuth: true, requiresPrivileges: ['ManageProduct'] },
                                    component: () => import('@/views/master-data/products/create')
                                },
                                {
                                    path: 'detail/:productId',
                                    name: 'products_detail',
                                    meta: { label: 'Thông tin', requiresAuth: true, param: 'productId', requiresPrivileges: ['ViewProduct'] },
                                    component: () => import('@/views/master-data/products/detail')
                                },
                                {
                                    path: 'edit/:productId',
                                    name: 'products_edit',
                                    meta: { label: 'Thông tin', requiresAuth: true, param: 'productId', requiresPrivileges: ['ManageProduct'], editing: true, },
                                    component: () => import('@/views/master-data/products/detail')
                                },
                                {
                                    path: 'manage-images/:productId',
                                    name: 'manage_image_products_detail',
                                    meta: { label: 'Quản lý ảnh sản phẩm', requiresAuth: true, param: 'productId', requiresPrivileges: ['ManageProductImage'] },
                                    component: () => import('@/views/master-data/products/images')
                                },

                            ]
                        },
                        {
                            path: 'blog-categories',
                            name: 'blog_categories',
                            redirect: '/master-data/blog-categories/list',
                            meta: { label: 'Thể loại bài viết' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'blog_categories_list',
                                    meta: { label: 'Danh sách thể loại bài viết', requiresAuth: true, requiresPrivileges: ['ViewBlogCategory'] },
                                    component: () => import('@/views/master-data/blog-categories/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_blog_categories',
                                    meta: { label: 'Thêm mới thể loại bài viết', requiresAuth: true, requiresPrivileges: ['ManageBlogCategory'] },
                                    component: () => import('@/views/master-data/blog-categories/create')
                                },
                                {
                                    path: 'detail/:blogCategoryId',
                                    name: 'blog_categories_detail',
                                    meta: { label: 'Thông tin thể loại bài viết', requiresAuth: true, param: 'blogCategoryId', requiresPrivileges: ['ViewBlogCategory'] },
                                    component: () => import('@/views/master-data/blog-categories/detail')
                                },
                                {
                                    path: 'edit/:blogCategoryId',
                                    name: 'blog_categories_edit',
                                    meta: { label: 'Thông tin thể loại bài viết', requiresAuth: true, param: 'blogCategoryId', requiresPrivileges: ['ManageBlogCategory'], editing: true, },
                                    component: () => import('@/views/master-data/blog-categories/detail')
                                }
                            ]
                        },
                        {
                            path: 'blogs',
                            name: 'blogs',
                            redirect: '/master-data/blogs/list',
                            meta: { label: 'Bài viết' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'blog_list',
                                    meta: { label: 'Danh sách bài viết', requiresAuth: true, requiresPrivileges: ['ViewBlog'] },
                                    component: () => import('@/views/master-data/blogs/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_blogs',
                                    meta: { label: 'Thêm mới bài viết', requiresAuth: true, requiresPrivileges: ['ManageBlog'] },
                                    component: () => import('@/views/master-data/blogs/create')
                                },
                                {
                                    path: 'detail/:blogId',
                                    name: 'blogs_detail',
                                    meta: { label: 'Thông tin bài viết', requiresAuth: true, param: 'blogId', requiresPrivileges: ['ViewBlog'] },
                                    component: () => import('@/views/master-data/blogs/detail')
                                },
                                {
                                    path: 'edit/:blogId',
                                    name: 'blogs_edit',
                                    meta: { label: 'Thông tin bài viết', requiresAuth: true, param: 'blogId', requiresPrivileges: ['ManageBlog'], editing: true, },
                                    component: () => import('@/views/master-data/blogs/detail')
                                }
                            ]
                        },
                        {
                            path: 'tags',
                            name: 'tags',
                            redirect: '/master-data/tags/list',
                            meta: { label: 'Thẻ bài viết' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'tag_list',
                                    meta: { label: 'Danh sách thẻ bài viết', requiresAuth: true, requiresPrivileges: ['ViewTag'] },
                                    component: () => import('@/views/master-data/tags/list')
                                },
                                {
                                    path: 'create',
                                    name: 'create_tag',
                                    meta: { label: 'Thêm mới thẻ bài viết', requiresAuth: true, requiresPrivileges: ['ManageTag'] },
                                    component: () => import('@/views/master-data/tags/create')
                                },
                                {
                                    path: 'detail/:tagId',
                                    name: 'tag_detail',
                                    meta: { label: 'Thông tin thẻ bài viết', requiresAuth: true, param: 'tagId', requiresPrivileges: ['ViewTag'] },
                                    component: () => import('@/views/master-data/tags/detail')
                                },
                                {
                                    path: 'edit/:tagId',
                                    name: 'tag_edit',
                                    meta: { label: 'Sửa thông tin thẻ bài viết', requiresAuth: true, param: 'tagId', requiresPrivileges: ['ManageTag'], editing: true, },
                                    component: () => import('@/views/master-data/tags/detail')
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'logs',
                    name: 'logs',
                    redirect: '/logs/action',
                    meta: { label: 'Nhật ký hệ thống' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'action',
                            name: 'action_logs',
                            redirect: '/logs/action/list',
                            meta: { label: 'Nhật ký người sử dụng' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'list',
                                    name: 'action_logs_list',
                                    meta: {
                                        label: 'Tra cứu các hoạt động thao tác dữ liệu trên hệ thống', requiresAuth: true, requiresPrivileges: ['ViewActionLog']
                                    },
                                    component: () => import('@/views/sys-logs/action/list'),
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/access-denied',
            name: 'access-denied',
            component: Page401
        },
        {
            path: '*',
            component: Page404
        }
    ]
})

router.beforeEach((to, from, next) => {
    var isAuthorized = true;
    for (var i = 0; i < to.matched.length; i++) {
        var route = to.matched[i];

        if (route.meta.requiresAuth) {
            // Check if this route require authentication
            if (!store.state.identity.isAuthenticated) {
                isAuthorized = false;
                break;
            }
            // Check if this route require admin permission
            else if (route.meta.adminOnly && !store.state.identity.isAdministrator) {
                isAuthorized = false;
                break;
            }
            // Check if this route require certain privileges
            else if (route.meta.requiresPrivileges && route.meta.requiresPrivileges.length > 0
                && intersect(store.state.identity.privileges, route.meta.requiresPrivileges).length == 0) {
                isAuthorized = false;
                break;
            }
        }
    }

    // if (isAuthorized) {
    //     next();
    // } else {
    //     next('/login');
    // }

    if (isAuthorized) {
        next();
    } else {
        if (store.state.identity.isAuthenticated) {
            next('/access-denied');
        }
        else
            next('/login');
    }
});

export default router;
